import React from 'react';
import styled, { css } from 'styled-components';
import BackgroundImage, { Overlay } from 'gatsby-theme-core/src/components/background-image';
import Container from 'gatsby-theme-core/src/components/container';
import ColorBackground from './color';
import Padding from '../section/padding';

const getImagePosition = (imagePosition) => {
  switch (imagePosition) {
    case 'container':
      return {
        $respectRatio: true,
      };
    case 'left_top':
      return {
        objectPosition: 'left top',
      };
    case 'left_center':
      return {
        objectPosition: 'left center',
      };
    case 'left_bottom':
      return {
        objectPosition: 'left bottom',
      };
    case 'center_30':
      return {
        objectPosition: 'center 30%',
      };
    case 'center_top':
      return {
        objectPosition: 'center top',
      };
    case 'center_center':
      return {
        objectPosition: 'center center',
      };
    case 'center_bottom':
      return {
        objectPosition: 'center bottom',
      };
    case 'right_top':
      return {
        objectPosition: 'right top',
      };
    case 'right_center':
      return {
        objectPosition: 'right center',
      };
    case 'right_bottom':
      return {
        objectPosition: 'right bottom',
      };
    default:
      return {};
  }
};

const getImageFit = (imageFit) => {
  switch (imageFit) {
    case 'cover':
      return {
        objectFit: 'cover',
      };
    case 'contain':
      return {
        objectFit: 'contain',
      };
    case 'fill':
      return {
        objectFit: 'fill',
      };
    case 'none':
      return {
        objectFit: 'none',
      };
    case 'scale_down':
      return {
        objectFit: 'scale-down',
      };
    default:
      return {};
  }
};

const getImageOverlay = (imageOverlay) => {
  switch (imageOverlay) {
    case 'lighten':
      return {
        lighten: true,
      };
    case 'darken':
      return {
        darken: true,
      };
    case 'darker':
      return {
        darker: true,
      };
    case 'standout':
      return {
        standout: true,
      };
    case 'fadeIn':
      return {
        fadeIn: true,
      };
    case 'fadeOut':
      return {
        fadeOut: true,
      };
    case 'fadeInAndOut':
      return {
        fadeInAndOut: true,
      };
    case 'fadeLeftToCenter':
      return {
        fadeLeftToCenter: true,
      };
    case 'fadeRightToCenter':
      return {
        fadeRightToCenter: true,
      };
    default:
      return {};
  }
};

const Background = ({
  className,
  image,
  imagePosition,
  imageFit,
  imageOverlay,
  color,
  customColor,
  children,
}) => (
  <ColorBackground
    className={className}
    color={color}
    customColor={customColor}
  >
    {!image?.localFile ? children : (
      <BackgroundImage
        className={className}
        image={image}
        {...getImageOverlay(imageOverlay)}
        {...getImagePosition(imagePosition)}
        {...getImageFit(imageFit)}
      >
        {children}
      </BackgroundImage>
    )}
  </ColorBackground>
);

export default styled(Background)`
  ${({ $size }) => ['flexHeight', 'fullHeight'].includes($size) && css`
    &, ${BackgroundImage} {
      display: flex;
      flex-grow: 1;
      ${Overlay}, ${Padding}, ${Container} {
        display: flex;
        flex-grow: 1;
      }
    }
  `}

  ${({ $size }) => $size === 'fullHeight' && css`
    &, ${BackgroundImage} {
      align-items: stretch;
      justify-content: center;
      min-height: 100vh;
      /* min-height: 100dvh; // this will make the page dance like crazy */
      scroll-snap-align: start;
    }
  `}

  ${({ $disableOnMobile }) => $disableOnMobile && css`
    @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
      .background-image {
        display: none;
      }
    }
  `}
`;
